module.exports = __webpack_public_path__ + "img/gratitude.e57f0035.png";